import angular from 'angular'
import template from './template.html'

export default class NominasPendientesCotizarProyectoNominaAprobarComponent {
  constructor (NominasNominaStatusAprobado) {
    this.NominasNominaStatusAprobado = NominasNominaStatusAprobado
    this.idProyecto = null
    this.idNomina = null
    this.status = null
    this.actualizando = false
  }

  toggle () {
    if (this.actualizando) return

    this.actualizando = true

    return this.NominasNominaStatusAprobado.put(this.idProyecto, this.idNomina, {status_aprobado: !this.status})
      .then((response) => (this.onChange({$event: {data: response.data}})))
      .finally(() => (this.actualizando = false))
  }
}

angular.module('nominas.pendientes')
  .component('nominasPendientesCotizarProyectoNominaAprobar', {
    controller: NominasPendientesCotizarProyectoNominaAprobarComponent,
    template: template,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      aprobado: '<',
      onChange: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/pendientes/components/cotizar/proyecto/nomina/aprobar/component.js